import axios from "axios";

const projects = {

    async create(data){
        return (await axios.post('/api/project', data)).data;
    },

    async clone(project_id){
        return (await axios.post(`/api/project/${project_id}/clone`)).data;
    },

    async updateSettings(project_id, data){
        return (await axios.put(`/api/project/${project_id}/settings`, data)).data;
    },

    async report(project_id, fields = ['student_count']){
        return (await axios.get(`/api/project/${project_id}/report`, {
            params: {fields},
        })).data;
    },

}

export default projects;
